import React, { Component } from "react";
import { setLoader } from "../../redux/actions";
import {
  Card,
  CardBody,
  CardTitle
} from "reactstrap";
import { connect } from "react-redux";
import FormCustom from "../../components/utils/FormCustom";
import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import { cloneDeep } from "lodash"
import AppLocale from "../../config/lang";

class FormSmart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formFields: props.fields,
      form: null,
      loaded: false,
      prevState: null,
      progressBar: false,
      // upload files
      dropzones: [],
      uploadActive: -1,
      uploadFiles: null,
    }
  }

  componentDidMount() {
    if (this.props.listenStates) this.props.listenStates(this.state.formFields)
    setTimeout(() => {
      this.getMyData();
    }, 300);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.formFields !== prevState.formFields) {
      if (this.props.listenStates) this.props.listenStates(this.state.formFields)
    }
  }

  listenStatesForm = (s) => {
    if (!this.props.fields) return
    let fields = cloneDeep(this.props.fields);
    fields.forEach((f, i) => {
      for (const [key, val] of Object.entries(s)) {
        if (f.name === key) fields[i].value = val
      }
    });

    this.setState({ formFields: fields, form: s });

    // Detect changes in form
    if (this.state.loaded && this.state.prevState !== null && this.state.prevState !== s) {
      if (this.props.buttons) this.props.buttons[0].disabled = false;
      this.forceUpdate();
    }
  }

  listenBtnActionsFormFilter = (a, s) => {
    if (a === 'save') {
      this.postMyData();
    }
  }

  uploadFiles (id) {
    return new Promise((resolve, reject) => {
      try {
        this.setState({ dropzones: this.props.fields.filter((e) => { return e.type === 'dropzone'}) }, () => {
          if (this.state.dropzones.length === 0) return resolve('empty')

          this.props.setLoader(true)

          let error = (e) => {
            this.setState({
              dropzones: [],
              uploadActive: -1,
              uploadFiles: null,
            })
            this.props.setLoader(false)
            reject(e)
          }

          let setUploadActive = () => {
            if (this.state.uploadActive < this.state.dropzones.length) {
              this.setState({
                uploadActive: this.state.uploadActive + 1}, () => {
                  if (this.state.uploadActive >= this.state.dropzones.length) {
                    this.props.setLoader(false)
                    return resolve('ok')
                  }
                  this.setState({
                    uploadFiles: {id: id, name: this.state.dropzones[this.state.uploadActive].name, success: setUploadActive, error: error },
                  })
                })
            }
          }

          if (this.state.dropzones.length > 0) {
            this.setState({uploadActive: 0}, () => {
              this.setState({
                uploadFiles: {id: id, name: this.state.dropzones[this.state.uploadActive].name, success: setUploadActive, error: error },
              })
            })
          }
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  getMyData() {
    var path = this.props.getUrl;
    let fields = cloneDeep(this.props.fields)

    if(!path && this.props.remapGET) {
      fields.forEach((f, i) => {
        for (const [key, val] of Object.entries(this.props.remapGET())) {
          if (f.name === key) fields[i].value = val
        }
      });

      this.setState({ formFields: fields, loaded: true, progressBar: false });
      this.setState({ prevState: this.state });
      return;
    }
    
    if(!path) {
      this.setState({ loaded: true });
      this.setState({ prevState: this.state });
      return;
    }

    let R = (r) => {
      if (this.props.remapGET) r = this.props.remapGET(r);
      else if (r && r.data) r = r.data;

      if (r) {
        fields.forEach((f, i) => {
          for (const [key, val] of Object.entries(r)) {
            if (f.name === key) fields[i].value = val
          }
        });
      }
      
      this.setState({ formFields: fields, loaded: true, progressBar: false });
      this.setState({ prevState: this.state });

      // disable save button
      if (this.props.buttons) this.props.buttons[0].disabled = true;
      this.forceUpdate();
    };

    if (!path) R();
    else _axios
      .get(path)
      .then(R).catch(e => {
        console.log(e);
      })
  }

  postMyData() {
    this.validateForm().then(() => {
      this.setState({ progressBar: true });
      this.props.buttons[0].disabled = true;
      this.forceUpdate();

      var path = this.props.postUrl;

      let body = cloneDeep(this.state.form)
      delete body.flags
      delete body.selectedField

      _axios
        .post(path, body)
        .then(r => {
          this.setState({ progressBar: false });

          if (r.status === 0) {
            this.uploadFiles(r.data).then((response) => {
              NotificationManager.success(r.msg || this.props.okMsg, this.props.title, 5000, null, null, 'outline');
              if (this.props.onSuccess) this.props.onSuccess(this)
            }).catch(e => {
              this.props.buttons[0].disabled = false;
              this.forceUpdate();
              console.log(e);
            });
          }
          else {
            NotificationManager.error(r.msg, this.props.title, 10000, null, null, 'outline');
            this.props.buttons[0].disabled = false;
            this.forceUpdate();
          }
        })
        .catch((e) => {
          this.props.buttons[0].disabled = false;
          this.forceUpdate();
        })
    })
    .catch(e => {
      NotificationManager.error("Campos requeridos", "Completar los campos requeridos", 3000, null, null, 'outline')
    })
  }

  getSkeleton() {
    if (!this.state.formFields) return
    let temp = cloneDeep(this.state.formFields);

    temp.forEach(e => {
      if (['label', 'dropzone'].indexOf(e.type) === -1) e.value = e.value === true || e.value === false ? false : '...';
    });

    return temp;
  }

  showTooltip(field) {
    if (this.props.listenBtnActions) this.props.listenBtnActions('tooltip', field);
  }

  render() {
    const { locale } = this.props
    const L = AppLocale[locale].messages
    const p = this.props
    return (
      <Card className={p.wrapClassName?? ""}>
        <div style={{ height: '4px' }}>{this.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}</div>
        <CardBody style={{ marginBottom: '-30px' }}>
          {p.title && <CardTitle> {L[p.title]?? p.title}</CardTitle>}
          {!this.state.loaded && <div><FormCustom
            fields={this.getSkeleton()}
          /></div>}
          {this.state.loaded && <FormCustom
            id={"form-crud"}
            fields={this.state.formFields}
            buttons={p.buttons}
            wrapButtonsWithDiv={true}
            listenStates={this.listenStatesForm}
            listenBtnActions={this.listenBtnActionsFormFilter}
            validate={ctx => this.validateForm = ctx}
            onTooltip={e => this.showTooltip(e)}
            uploadFiles={this.state.uploadFiles}
            detailGrid={this.props.detailGrid}
            subforms={this.props.subforms}
          />}
        </CardBody>
      </Card>
    );
  }
};

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale };
};

export default connect(mapStateToProps, { setLoader })(FormSmart);